"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryDecode = tryDecode;
exports.parse = parse;
/**
 * These are helper functions required by and based on the cookie-store polyfill package: https://github.com/markcellus/cookie-store
 */
const decodeUri = decodeURIComponent;
const pairSplitRegExp = /; */;
function tryDecode(str, decode) {
    try {
        return typeof decode === 'boolean' ? decodeURIComponent(str) : decode(str);
    }
    catch (e) {
        throw e;
    }
}
function parse(str) {
    const obj = [];
    const pairs = str.split(pairSplitRegExp);
    for (const pair of pairs) {
        let eqIdx = pair.indexOf('=');
        // skip things that don't look like key=value
        if (eqIdx < 0) {
            continue;
        }
        const key = pair.substring(0, eqIdx).trim();
        let val = pair.substring(++eqIdx, pair.length).trim();
        // quoted values
        if (val.startsWith('"')) {
            val = val.slice(1, -1);
        }
        // only assign once
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        if (!obj.some((cookie) => cookie.name === key)) {
            obj.push({
                name: key,
                value: tryDecode(val, decodeUri)
            });
        }
    }
    return obj;
}
//# sourceMappingURL=CookieParser.js.map